import * as Yup from 'yup';

const personNameSchema = Yup.object({
  LastName: Yup.string()
    .nullable()
    .required('Last Name is required')
    .max(100, 'Last Name cannot exceed 100 characters'),

  FirstName: Yup.string().nullable().max(100, 'First Name cannot exceed 100 characters'),

  MiddleName: Yup.string().nullable().max(50, 'Middle Name cannot exceed 50 characters'),

  NickName: Yup.string().nullable().max(20, 'Nick Name cannot exceed 20 characters'),

  NameType: Yup.string().nullable().required('Name Type is required'),

  Notes: Yup.string().nullable().max(2000, 'Notes cannot exceed 2000 characters'),
});

export default personNameSchema;
